import type { ChosenVisibility } from '@/infrastructure/api/v1/mappers/stories';

export const VISIBILITY_OPTIONS = [
  { id: 'public', label: 'Public' },
  { id: 'unlisted', label: 'Unlisted' },
] as const satisfies ReadonlyArray<{ id: ChosenVisibility; label: string }>;

export const VISIBILITY_HINT: Record<ChosenVisibility, string> = {
  public: 'Story will be visible in the Lureo app',
  unlisted: 'Story will only be reachable by a link you share',
};

/** Right under the publish flow's Public | Unlisted choice: what the chosen one means. */
export const VISIBILITY_SWITCH_HINT: Record<ChosenVisibility, string> = {
  public: 'Anyone can find it in the Lureo app',
  unlisted: 'Only people with the link can open it',
};
